import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { Checkout } from '@df/checkout/checkout.interfaces';
import { Address } from '@df/session/api/address-book/address';
import { SizeClassDirective } from '@df/ui/common/size-class.directive';
import { ToAddressPipeService } from '@df/ui/common/to-address.pipe';
import { TranslatePipe } from '@df/ui/translation/translate.pipe';
import { CheckoutAddressModelComponent } from './checkout-address-model.component';
import { CheckoutFormComponent } from './checkout-form.component';

@Component({
    selector: 'checkout-payment-address-status',
    templateUrl: './checkout-payment-address-status.html',
    standalone: true,
    imports: [CheckoutAddressModelComponent, CommonModule, SizeClassDirective, TranslatePipe]
})
export class CheckoutPaymentAddressStatusComponent {
    constructor(
        public checkoutFormComponent: CheckoutFormComponent,
        protected toAddressPipe: ToAddressPipeService
    ) {}
    /**
     * Shipping address
     */
    get billingAddress(): Checkout.IAddress | undefined {
        return this.checkoutFormComponent.isBillingToShipping && this.checkoutFormComponent.hasDeliveryAddress
            ? this.checkoutFormComponent.data.address.shipping
            : this.checkoutFormComponent.data.address.billing;
    }
    /**
     * Shipping address
     */
    get billingAddressModel(): Address | undefined {
        return this.toAddressPipe.transform(this.billingAddress);
    }
    /**
     * Change email and go to step of given name
     */
    change() {
        this.checkoutFormComponent.changePaymentAddress = true;
        this.checkoutFormComponent.detectChanges();
    }
}
